module.exports = __webpack_public_path__ + "static/media/Tropical.e4d63d66.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tropical.jpeg
// module id = 242
// module chunks = 0